module.exports = __webpack_public_path__ + "static/media/41-5.b9ed6192.mp3";